import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './rightForm';
import List from './rightList';

const settings = {
    pathRegister: paths.rightRegister,
    pathList: paths.right,
    apiPath: 'right',
    permissionAdmin: null,
    title: 'Direitos de usuários',
};

const Right: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={{ ...settings, title: 'Direito de usuário' }} />
        </MainContainer>
    );
};

const RightList: React.FC = () => {
    return (
        <MainContainer>
            <List settings={settings} />
        </MainContainer>
    );
};

export { Right, RightList };
